<template>
  <v-dialog
    :value="shown"
    persistent
    max-width="450"
    @click:outside="hideModal"
    @keydown.esc="hideModal"
  >
    <div class="login">
      <div class="card-head">
        <v-btn
          icon
          dark
          @click="hideModal"
          class="hide-button"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <h2>Sign in</h2>
      </div>
      <div class="inputs">
        <v-text-field
          v-model="email"
          label="Email"
          filled
          autocomplete="username"
          :rules="rules.required.concat(rules.email)"
          @keyup.enter="login"
        ></v-text-field>
        <v-text-field
          v-model="password"
          label="Password"
          type="password"
          filled
          :rules="rules.required.concat(rules.password)"
          @keyup.enter="login"
        ></v-text-field>
      </div>
      <v-alert
        v-if="errorMessage"
        text
        type="error"
        class="pr-10"
      >
        {{ errorMessage }}
      </v-alert>
      <div class="controls">
        <v-btn
          x-large
          color="#f0b323"
          @click="login"
          :disabled="!email || !password || isLoading"
        >
        SIGN IN →
        </v-btn>
        <a @click="remindPassword">Forgot password?</a>
      </div>
    </div>
  </v-dialog>
</template>

<script>
export default {
  name: 'login-modal',
  props: {
    shown: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isLoading: false,
      email: '',
      password: '',
      errorMessage: '',
      valid: true,
      rules: {
        required: [
          value => !!value || 'Required'
        ],
        email: [
          value => value.length >= 2 || 'Minimum 2 characters'
        ],
        password: [
          value => value.length >= 8 || 'Minimum 8 characters'
        ]
      }
    }
  },
  methods: {
    hideModal () {
      this.$emit('hide')
    },
    remindPassword () {
      this.$emit('recover')
    },
    login () {
      this.isLoading = true
      this.errorMessage = ''
      const { email, password } = this
      this.$store.dispatch('user/login', { login: email, password })
        .then(res => {
          this.isLoading = false
          this.clearFields()
          this.hideModal()
        })
        .catch(err => {
          this.isLoading = false
          this.errorMessage = err.response
            ? err.response.data.message
            : err.message
        })
    },
    clearFields () {
      this.email = ''
      this.password = ''
    }
  }
}
</script>

<style scoped lang="scss">
.hide-button {
  position: absolute;
  top: 30px;
  right: 30px;
}
.login {
  background: #FFFFFF;
  box-shadow: 0px 23px 28px rgba(0, 0, 0, 0.213768);
  border-radius: 7px;
}
.card-head {
  position: relative;
  background: #18305A;
  height: 200px;
  display: flex;
  align-items: flex-end;
  padding-left: 55px;
  padding-right: 55px;
  h2 {
    color: #fff;
    padding-bottom: 30px;
  }
}
.inputs {
  padding: 55px;
}
.controls {
  display: flex;
  justify-content: space-between;
  padding: 20px 55px 50px;
  align-items: center;
}
</style>
